import React from 'react'
import PropTypes from 'prop-types'
import { observer, inject } from 'mobx-react'
import hexToRgba from 'hex-to-rgba'

import LongTextModel, { NULL as LongTextModelNULL } from './model'
import EditorModel, {
  NULL as EditorModelNULL,
} from '@client/components/Editor/model'
import AppModel, { NULL as AppModelNULL } from '@client/components/App/model'
import { BLOCK_TYPES, FIELD_TYPES } from '@client/components/Block/constants'
import { defaultText } from './constants'
import {
  getValueOrDefaultText,
} from '@client/utils/getValueOrDefault'

import inlineStyles from './inlineStyles'

import './../styles.scss'

export const LongText = ({
  model = LongTextModelNULL,
  editor = EditorModelNULL,
  app = AppModelNULL,
  serverRender = false,
}) => {
  const globalSettings = editor.settings.values
  const settings = model.settings.values
  const isRequired = settings.isRequired || false

  const question = getValueOrDefaultText(
    settings.question,
    defaultText.question
  )

  const hasHelpText = settings.hasHelpText || false

  const helpText = getValueOrDefaultText(
    settings.helpText,
    defaultText.helpText
  )

  return (
    <div
      data-type={BLOCK_TYPES.FIELD}
      data-field-type={FIELD_TYPES.SHORT_TEXT}
      className={`gan-field gan-field-${model.inputName} ${
        isRequired ? 'gan-field-required' : ''
      }`}
    >
      <label
        style={{
          ...inlineStyles.label,
          color: globalSettings.normalText_color,
          fontFamily: globalSettings.normalText_fontFamily,
        }}
      >
        {question}
      </label>
      {hasHelpText && (
        <span
          className="help-text"
          style={{
            fontFamily: globalSettings.normalText_fontFamily,
          }}
        >
          {helpText}
        </span>
      )}
      <textarea
        placeholder={app.formatMessage('fields.longtext.answer.placeholder')}
        required={isRequired}
        name={model.inputName}
        className={
          'rounded-md border-gray-300 shadow-sm focus:border-indigo-300 ' +
          'focus:ring focus:ring-indigo-200 focus:ring-opacity-50'
        }
        style={{
          width: '100%',
          padding: '5px 10px',
          fontSize: '16px',
          fontFamily: globalSettings.normalText_fontFamily,
          '--tw-ring-color': hexToRgba(globalSettings.themeColor, 1).replace(
            '1)',
            'var(--tw-ring-opacity))'
          ),
          backgroundColor: 'transparent',
        }}
        rows={4}
      />
      <div
        className="gan-validation-field-error"
        style={{
          color: 'red',
          fontSize: `${globalSettings.normalText_fontSize * 0.7}px`,
        }}
      />
    </div>
  )
}

LongText.propTypes = {
  model: PropTypes.instanceOf(LongTextModel),
  editor: PropTypes.instanceOf(EditorModel),
  app: PropTypes.instanceOf(AppModel),
  serverRender: PropTypes.bool,
}

export default inject('editor', 'serverRender', 'app')(observer(LongText))
